import { styled } from "goober";
import {
  type ScrollRestorationOptions,
  useScrollRestoration,
} from "../hooks/useScrollRestoration";

const Container = styled("div")`
  height: 100%;
  overflow: auto;
  overscroll-behavior: none;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

type Props = ScrollRestorationOptions & {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export function MainScrollContainer({
  children,
  style,
  active,
  ready,
  resetOnNavigate,
}: Props) {
  const scrollRef = useScrollRestoration<HTMLDivElement>({
    active,
    ready,
    resetOnNavigate,
  });

  return (
    <Container ref={scrollRef} style={style}>
      {children}
    </Container>
  );
}
